/* eslint-disable no-unused-vars */
/* eslint-disable-next-line no-shadow */
export enum TargetMarketSelectionReasons{
  TierReceivedEnquiries = 101,
  TierMarketPresentsGoodProspects = 102,
  TierLookingForOpportunitiesInNewMarkets = 103,
  TierSuccessfullyExportedToSimilarMarkets = 104,
  TierPursuingTendersInTargetMarkets = 105,
  TierExploringOpporunitiesInFTAMarkets = 106,
  TierParticipatingInTradePromtionPrograms =107,
  TierChangesInRegulatoryRequirements = 108,
  TierOtherReasons = 109,
  RepBodyReceivedEnquiries = 201,
  RepBodyMarketPresentsGoodProspects = 202,
  RepBodyLookingForOpportunitiesInNewMarkets = 203,
  RepBodySuccessfullyExportedToSimilarMarkets = 204,
  RepBodyPursuingTendersInTargetMarkets = 205,
  RepBodyExploringOpporunitiesInFTAMarkets = 206,
  RepBodyParticipatingInTradePromtionPrograms = 207,
  RepBodyChangesInRegulatoryRequirements = 208,
  RepBodyOtherReasons = 209,
}
